import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class InventoryCounts_ds_material_selector_gridService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { projectId?: number, isExclude: boolean, materialIds: number[], statusId?: number, storageCategoryRuleId?: number, fullTextSearch?: string }): 
  Promise<{ result: { Id?: number, Description?: string, LookupCode?: string, Status?: { Id?: number, Name?: string }, StorageCategoryRule?: { Id?: number, Name?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.isExclude)) {
      missingRequiredInParams.push('\'isExclude\'');
    }
    if (isNil(inParams.materialIds)) {
      missingRequiredInParams.push('\'materialIds\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/InventoryCounts/datasources/ds_material_selector_grid/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { projectId?: number, isExclude: boolean, materialIds: number[], statusId?: number, storageCategoryRuleId?: number, fullTextSearch?: string, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, Description?: string, LookupCode?: string, Status?: { Id?: number, Name?: string }, StorageCategoryRule?: { Id?: number, Name?: string } }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.isExclude)) {
      missingRequiredInParams.push('\'isExclude\'');
    }
    if (isNil(inParams.materialIds)) {
      missingRequiredInParams.push('\'materialIds\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/InventoryCounts/datasources/ds_material_selector_grid/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { projectId?: number, isExclude: boolean, materialIds: number[], statusId?: number, storageCategoryRuleId?: number, fullTextSearch?: string, $keys: number[] }): 
  Promise<{ result: { Id?: number, Description?: string, LookupCode?: string, Status?: { Id?: number, Name?: string }, StorageCategoryRule?: { Id?: number, Name?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.isExclude)) {
      missingRequiredInParams.push('\'isExclude\'');
    }
    if (isNil(inParams.materialIds)) {
      missingRequiredInParams.push('\'materialIds\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/InventoryCounts/datasources/ds_material_selector_grid/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      projectId?: number, isExclude: boolean, materialIds: number[], statusId?: number, storageCategoryRuleId?: number, fullTextSearch?: string    }) {
        if(isNil(inParams.isExclude)) {
          return true; 
        }
        if(isNil(inParams.materialIds)) {
          return true; 
        }
      return false;
    }
}
